import { FormItem, BringgTextArea } from '@bringg/react-components';
import { useTranslation } from 'react-i18next';

import { coordinatesToPolygon } from 'bringg-web/features/service-area/utils/coordinates-to-polygon';
import { checkIfPolygon } from '../utils/check-if-polygon';

export function ServiceAreaCoordinatesInput() {
	const { t } = useTranslation();
	const validate = async func => Promise.resolve().then(() => func());

	return (
		<FormItem
			validateFirst
			rules={[
				{ required: true, message: t('SERVICE_AREA.CANT_BE_EMPTY') },
				{
					validator: async (_, value) => validate(() => coordinatesToPolygon(value)),
					message: t('SERVICE_AREA.CANT_PARSE')
				},
				{
					validator: async (_, value) => validate(() => checkIfPolygon(coordinatesToPolygon(value))),
					message: t('SERVICE_AREA.THREE_COORDINATES_REQUIRED')
				}
			]}
			name="coordinates"
		>
			<BringgTextArea
				data-test-id="service-area-coordinates"
				className="textarea-input"
				placeholder="[&#10;[ lat, long ],&#10;[ 12.2123313, 12.2323232 ],&#10;]"
			/>
		</FormItem>
	);
}
